import _ from 'underscore';
import $ from 'jquery';

export default class UserExport {
  constructor($scope, $filter, $timeout) {
    $scope.export_options = [
      {
        id: 'users',
        title: 'Users'
      },
      {
        id: 'contacts',
        title: 'Contacts'
      },
      {
        id: 'addresses',
        title: 'Addresses'
      },
      {
        id: 'user_categories',
        title: 'User Product Categories'
      },
      {
        id: 'contact_categories',
        title: 'Contact Product Categories'
      }
    ];

    $scope.user_roles = [
      {
        id: 0,
        name: 'Buyer'
      },
      {
        id: 1,
        name: 'Seller'
      },
      {
        id: 2,
        name: 'Both'
      }
    ];

    $scope.init_filter = function() {
      $scope.filter = {
        role_id: 0,
        countries: [],
        date_from: null,
        date_to: null
      };
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '600px'
    };
    
    $scope.select2_options_447 = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '447px'
    };

    $scope.export = function() {
      $timeout(function() {
        $('form#getXLS input[name="filter"]').val(JSON.stringify($scope.filter));
        $('form#getXLS input[name="mode"]').val($scope.export_option);
        $('form#getXLS').submit();
      }, 300);
    };
    
    $scope.toggleEUcountries = function toggleEUcountries(check_eu_countries) {
      if (check_eu_countries){
        if (!$scope.filter.countries) {
          $scope.filter.countries = [];
        }
        $scope.filter.countries = $scope.filter.countries.concat($scope.eu_countries);
      } else {
        $scope.filter.countries = _.difference($scope.filter.countries,$scope.eu_countries);
      }
      $('#countries').select2('val', $scope.filter.countries);
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.init = function() {
      $scope.export_option = $scope.export_options[0].id;
      $scope.eu_countries = window.eu.countries.map(a => String(a.id));
      $scope.init_filter();
      if (_.difference($scope.eu_countries, $scope.filter.countries).length === 0) {
        $scope.check_eu_countries = true;
      }
    };

    $scope.init();

  }
}

UserExport.$inject = ['$scope', '$filter', '$timeout'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-export.ctrl.js